import * as React from "react";

export const SvgAddPassenger = ({ color, ...props }) => (
	<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M12.9992 0.200195C5.94087 0.200195 0.199219 5.94184 0.199219 13.0002C0.199219 20.0585 5.94087 25.8002 12.9992 25.8002C20.0576 25.8002 25.7992 20.0575 25.7992 13.0002C25.7992 5.94284 20.0576 0.200195 12.9992 0.200195ZM12.9992 23.8172C7.03547 23.8172 2.18217 18.9649 2.18217 13.0002C2.18217 7.03545 7.03547 2.18315 12.9992 2.18315C18.963 2.18315 23.8163 7.03545 23.8163 13.0002C23.8163 18.9649 18.964 23.8172 12.9992 23.8172Z"
			fill={color}
			stroke={color}
			strokeWidth="0.2"
		/>
		<path
			d="M17.9571 11.9193H13.9912V7.95341C13.9912 7.40611 13.548 6.96191 12.9997 6.96191C12.4514 6.96191 12.0082 7.40611 12.0082 7.95341V11.9193H8.04228C7.49398 11.9193 7.05078 12.3635 7.05078 12.9108C7.05078 13.4581 7.49398 13.9023 8.04228 13.9023H12.0082V17.8682C12.0082 18.4155 12.4514 18.8597 12.9997 18.8597C13.548 18.8597 13.9912 18.4155 13.9912 17.8682V13.9023H17.9571C18.5054 13.9023 18.9486 13.4581 18.9486 12.9108C18.9486 12.3635 18.5054 11.9193 17.9571 11.9193Z"
			fill={color}
			stroke={color}
			strokeWidth="0.2"
		/>
	</svg>
);
